import React, { useCallback } from 'react';

import ChevronRightLargeIcon from '@atlaskit/icon/glyph/chevron-right-large';

import { CarouselButtonStyled } from '../../../styled/StyledModal';
import { useButtonEventHandler } from '../../../hooks/analytics-handlers/useButtonEventHandler';

export const NextButton = ({
	slideLength,
	activeSlide,
	setActiveSlide,
}: {
	slideLength: number;
	activeSlide: number;
	setActiveSlide: (activeSlide: number) => void;
}) => {
	const { eventHandler } = useButtonEventHandler();

	const handleOnClick = useCallback(() => {
		eventHandler({
			actionSubjectId: 'carousel-next-button',
			pageIdx: activeSlide,
		});

		setActiveSlide(activeSlide + 1);
	}, [activeSlide, eventHandler, setActiveSlide]);

	return (
		<CarouselButtonStyled onClick={handleOnClick} disabled={activeSlide === slideLength - 1}>
			<ChevronRightLargeIcon label="next" />
		</CarouselButtonStyled>
	);
};
